<template>
  <div>
    <div v-if="is_loading" class="is-flex is-align-items-center is-justify-content-center">
      <div class="loading"></div>
    </div>
    <div v-for="inactive_position in inactive_positions" :key="inactive_position.id" class="inactive_position is-flex is-align-items-center">
      <div class="is-flex is-align-items-center">
        <p><b>COMPANY:</b></p>
        <div class="horizontal_space"></div>
        <link-entity :payload="inactive_position.company" :additional_data="{ resource_type: 'Company' }"></link-entity>
      </div>
      <div class="horizontal_space"></div>
      <div class="is-flex is-align-items-center">
        <p><b>POSITION:</b></p>
        <div class="horizontal_space"></div>
        <link-entity :payload="inactive_position" :additional_data="{ resource_type: 'Position' }"></link-entity>
      </div>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
export default {
  name: 'inactive-outsource-hot-positions',
  data () {
    return {
      inactive_positions: [],
      is_loading: true
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      let hot_positions_request = this.$network_utils.getAllPositions({ status: 'active', is_hot: true })
      let active_outsource_positions_request = this.$network_utils.getOutsourcePositions({ env: this.$settings.get({ path: 'operation_name' }), status: 'active' })
      let requests = [hot_positions_request, active_outsource_positions_request]
      this.$caller.axios.all(requests).then(response => {
        let hot_positions = response[0]
        let outsource_positions = response[1]
        this.inactive_positions = hot_positions.filter(hot_position => {
          let is_outsourced = false
          for (let i = 0; i < outsource_positions.length; i++) {
            let outsource_position = outsource_positions[i]
            if (outsource_position.env_position_id == hot_position.id) {
              is_outsourced = true
            }
          }
          return !is_outsourced
        })
        this.is_loading = false
      })
    }
  },
  components: {
    LinkEntity
  }
}
</script>
<style scoped>
  .inactive_position {
    margin-bottom: 30px;
  }
</style>
